import * as React from 'react';
import { Modal, Button, Typography, Box } from '@material-ui/core';
import { toast } from 'react-toastify';
import { removeStudentPhone } from '../services/api';

/**
 * Modal for removing user phone number
 * Simple confirmation before deletion
 */
export default function RemovePhoneModal({ params, openModal, setOpenModal }) {
  const [loading, setLoading] = React.useState(false);
  const currentPhone = params.data.phone;

  const handleRemove = async () => {
    setLoading(true);
    try {
      await removeStudentPhone({
        userId: params.data.id,
      });

      toast.success('Phone number removed successfully');
      setOpenModal(false);

      // Refresh grid if available
      if (params.context?.refreshGrid) {
        params.context.refreshGrid();
      }
    } catch (error) {
      console.error('Error removing phone:', error);
      const message =
        error.response?.data?.message || 'Failed to remove phone number';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/3 w-11/12 border-solid border border-gray-300'>
        <div
          className='absolute right-4 top-4 cursor-pointer text-gray-600 hover:text-gray-900'
          onClick={handleClose}
        >
          ✕
        </div>

        <Typography variant='h6' component='h2' className='mb-4 pr-8'>
          Remove Phone Number
        </Typography>

        <Typography variant='body1' className='mb-4'>
          Are you sure you want to remove the phone number{' '}
          <strong>{currentPhone}</strong> from this user&apos;s profile?
        </Typography>

        <Typography variant='caption' className='text-gray-600 mb-4 block'>
          This action cannot be undone. The phone number will be permanently deleted.
        </Typography>

        <Box className='flex justify-end gap-2 mt-6'>
          <Button
            variant='outlined'
            onClick={handleClose}
            disabled={loading}
            className='text-gray-600 border-gray-300'
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='secondary'
            onClick={handleRemove}
            disabled={loading}
          >
            {loading ? 'Removing...' : 'Remove Phone'}
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
